import React, { Component } from 'react/index'
import Header from '../components/header/index'
import Intro from '../components/intro/index'
import FullMenu from '../components/fullMenu/index'
import Slider from '../components/slider/index'
import Typist from 'react-typist'
import Mouse from '../components/mouse/index'
import { videos } from '../data/data.js'
import Explorer from '../components/explorer/explorer'
import { BROWSER } from '../browser-detect'

class IndexPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      revealSection: false,
      revealFullMenu: false,
      videoFromUrl: null
    }
  }
  componentWillMount() {
    const noIntro = localStorage.getItem('noIntro')
    console.log(noIntro)
    console.log(this.props)
    const { index } = this.props.match.params
    if (noIntro) {
      this.setState({ revealSection: true })
      this.handleFullMenu()
    }
    if (index) {
      this.setActiveVideoFromUrl(index)
    }
  }

  setActiveVideoFromUrl = index => this.setState({ videoFromUrl: index })

  watchedIntro = divIsRemoved => {
    console.log(divIsRemoved)
    if (divIsRemoved) {
      this.handleMain()
      this.handleFullMenu()
    }
  }

  handleMain = () => {
    setTimeout(() => {
      this.setState({ revealSection: true })
      document.querySelector('.intro.animated.fadeOut').style.display = 'none'
    }, 2000)
  }

  handleFullMenu = () => {
    setTimeout(() => {
      this.setState({ revealFullMenu: true })
    }, 4000)
  }

  render() {
    const { revealSection, revealFullMenu, videoFromUrl } = this.state
    const noIntro = localStorage.getItem('noIntro')

    const MAIN_SECTION = (
			<section className='page_section'>
				<Header />
				<div className='main_content animated fadeInUp'>
					<p className='celebration_intro animated fadeInLeft'>
						View CetraRuddy’s DNA through 6 pillars which reflect
						our spirit, passion and journey, informing our process as we
						move forward.
					</p>
					<Slider
						videos={videos}
						activeVideo={this.state.videoFromUrl ? videoFromUrl : 0}
					/>
					<Mouse />
				</div>
			</section>
		)
    const FULL_MENU_SECTION = (
      <section className="page_section full_menu">
        <FullMenu videos={videos} />
      </section>
    )
    const conditionalMain = revealSection ? MAIN_SECTION : null
    const conditionalFull = revealFullMenu ? FULL_MENU_SECTION : null
    const conditionalIntro = noIntro ? null : <Intro handleIntroExit={this.watchedIntro} />

    if (BROWSER.isExplorer()) {
      return <Explorer videoFromUrl={videoFromUrl} />
    } else {
      return (
        <div className="">
          <main className="main">
            {conditionalIntro}
            {conditionalMain}
            {conditionalFull}
          </main>
        </div>
      )
    }
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js